import alloyAnalytics from '@telus/alloy-analytics'

const TOOL_NAME = 'imei_compatibility_checker'
const TOOL_TYPE = 'wizard'

const alloyEvents = {
  toolStart: (url: URL['href']) => {
    alloyAnalytics
      .event('toolStart')
      .webInteraction({
        name: '3g_check_compatibility',
        type: 'other',
        URL: url,
        toolName: TOOL_NAME,
        toolType: TOOL_TYPE,
      })
      .fire()
  },
  compatibilitySuccess: (url: URL['href']) => {
    alloyAnalytics
      .event('toolComplete')
      .webInteraction({
        name: '3g_check_compatibility_success',
        type: 'other',
        URL: url,
        toolName: TOOL_NAME,
        toolType: TOOL_TYPE,
        eventDetails: 'device_volte_compatible',
      })
      .fire()
  },
  compatibilitySuccessNoRoaming: (url: URL['href']) => {
    alloyAnalytics
      .event('toolComplete')
      .webInteraction({
        name: '3g_check_compatibility_success',
        type: 'other',
        URL: url,
        toolName: TOOL_NAME,
        toolType: TOOL_TYPE,
        eventDetails: 'device_volte_compatible_but_no_roaming',
      })
      .fire()
  },
  compatibilityNotCompatible: (url: URL['href']) => {
    alloyAnalytics
      .event('toolComplete')
      .webInteraction({
        name: '3g_check_compatibility_not_compatible',
        type: 'other',
        URL: url,
        toolName: TOOL_NAME,
        toolType: TOOL_TYPE,
        eventDetails: 'device_not_volte_compatible',
      })
      .fire()
  },
  deviceNotFound: (url: URL['href'], errorCode: string) => {
    alloyAnalytics
      .event('toolError')
      .webInteraction({
        name: '3g_check_compatibility_error',
        type: 'other',
        URL: url,
        toolName: TOOL_NAME,
        toolType: TOOL_TYPE,
        errorType: 'user',
        errorDetails: 'imei_format_error',
        errorMessage: 'device_not_found',
        errorCode,
        errorInstances: { value: 1 },
      })
      .fire()
  },
  genericError: (url: URL['href'], errorDetails: string, errorMessage: string, errorCode = '') => {
    alloyAnalytics
      .event('toolError')
      .webInteraction({
        name: '3g_check_compatibility_error',
        type: 'other',
        URL: url,
        toolName: TOOL_NAME,
        toolType: TOOL_TYPE,
        errorType: 'user',
        errorDetails,
        errorMessage,
        errorCode,
        errorInstances: { value: 1 },
      })
      .fire()
  },
  validationError: (url: URL['href'], errorMessage: string) => {
    alloyAnalytics
      .event('toolError')
      .webInteraction({
        name: '3g_check_compatibility_error',
        type: 'other',
        URL: url,
        toolName: TOOL_NAME,
        toolType: TOOL_TYPE,
        errorType: 'user',
        errorDetails: 'imei_format_error',
        errorMessage,
        errorInstances: { value: 1 },
      })
      .fire()
  },
}

export default alloyEvents
